export default class StackCaptureError extends Error {
  constructor(...params) {
    super(...params);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, StackCaptureError);
    }
  }
}
